<div class="chat-container mt-0 ps-2 pe-2 pb-0">
  <div class="chat-toolbar mt-0">
    <div class="toolbar-content justify-content-between">
      <div class="d-flex align-items-center justify-content-start">
        <button mat-icon-button [matMenuTriggerFor]="menu" [tabIndex]="-1">
          <mat-icon style="color: #757575;">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="clearChat()">Clear chat</button>
          <button mat-menu-item (click)="closeChat()">Close</button>
        </mat-menu>
        <img src="../../../../assets/images/ai/rachel-ai10.png" alt="Rachel" class="profile-pic ms-2" />
        <span class="user-name" style="color: #673ab7;">Rachel</span>
      </div>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="toggleSize()" [tabIndex]="-1">
          <mat-icon style="color: #757575;">
            {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
          </mat-icon>
        </button>
        <button mat-icon-button (click)="toggleExpand()" [tabIndex]="-1">
          <mat-icon style="color: #757575;">minimize</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="chat-window rounded-bottom" #chatWindow>
    <div class="chat-header mt-2 mb-4 text-center">
      <b>
        <span style="font-size: 24px;">How can </span>
        <span style="font-size: 30px; color: #673ab7;">Rachel</span>
        <span style="font-size: 24px;"> help?</span>
      </b>
    </div>
    <!-- <div *ngFor="let message of aiChatService.chatHistory$ | async" class="message" [ngClass]="message.sender">
      <mat-card [@messageAnimation]="message.sender">
        <div [innerHTML]="message.text"></div>
        <company-card-component [companies]="aiChatService.companyDomains"></company-card-component>
        <div *ngIf="message.isTyping" class="typing-indicator">
          <span></span><span></span><span></span>
        </div>
        <div class="timestamp">{{ message.timestamp | date: 'shortTime' }}</div>
      </mat-card>
    </div> -->
    <!-- <div *ngFor="let message of aiChatService.chatHistory$ | async" class="message" [ngClass]="message.sender">
      <mat-card [@messageAnimation]="message.sender">
        <div *ngIf="!message.text.includes('[[COMPANY_CARD]]')" [innerHTML]="message.text | safeHtml"></div>
        <ng-container *ngIf="message.text.includes('[[COMPANY_CARD]]')">
          <div [innerHTML]="message.text.split('[[COMPANY_CARD]]')[0] | safeHtml"></div>
          <company-card-component [companies]="aiChatService.companyDomains"></company-card-component>
        </ng-container>
        <div *ngIf="message.isTyping" class="typing-indicator">
          <span></span><span></span><span></span>
        </div>
        <div class="timestamp">{{ message.timestamp | date: 'shortTime' }}</div>
      </mat-card>
    </div> -->

    <div *ngFor="let message of aiChatService.chatHistory$ | async" class="message" [ngClass]="message.sender">
      <mat-card [@messageAnimation]="message.sender">
        <div *ngIf="!message.text.includes('[[COMPANY_CARD]]')" [innerHTML]="message.text | safeHtml"></div>
        <ng-container *ngIf="message.text.includes('[[COMPANY_CARD]]')">
          <div [innerHTML]="message.text.split('[[COMPANY_CARD]]')[0] | safeHtml"></div>
          <company-card-component [companies]="message.companies || []"></company-card-component>
        </ng-container>
        <div *ngIf="message.isTyping" class="typing-indicator">
          <span></span><span></span><span></span>
        </div>
        <div class="timestamp">{{ message.timestamp | date: 'shortTime' }}</div>
      </mat-card>
    </div>
  </div>

  <div class="mat-form-field-like">
    <div class="mat-form-field-wrapper">
      <label>Rachel Expertise:</label>
      <div class="mat-form-field-content">
        <mat-chip-grid>
          <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.RecommendSoftware"
            [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.RecommendSoftware)">
            <small>Recommend software</small>
          </mat-chip-option>
          <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.FindCustomers"
            [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.FindCustomers)">
            <small>Find customers of products</small>
          </mat-chip-option>
          <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.AnalyzeTechStacks"
            [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.AnalyzeTechStacks)">
            <small>Analyze tech stacks for companies</small>
          </mat-chip-option>
          <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.BenchmarkCompanies"
            [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.BenchmarkCompanies)">
            <small>Benchmark companies</small>
          </mat-chip-option>
          <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.GeneralMode"
            [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.GeneralMode)">
            <small>General Technology</small>
          </mat-chip-option>
          <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.ProductAnalysis"
          [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.ProductAnalysis)">
          <small>Product Analysis</small>
        </mat-chip-option>
        <mat-chip-option [selected]="aiChatService.selectedMode === chatCommand.FindEmployees"
          [disabled]="aiChatService.isLoading" (click)="chipSelected(chatCommand.FindEmployees)">
          <small>Find People profiles</small>
        </mat-chip-option>
        </mat-chip-grid>
      </div>
    </div>
  </div>


  <mat-form-field appearance="outline" class="chat-input p-0 mt-2" subscriptSizing="dynamic">
    <input
      matInput
      [(ngModel)]="userInput"
      autofocus
      placeholder="Ask Rachel anything..."
      (keyup)="onKeyUp($event)"
      #inputField
      class="futuristic-input"
    >
    <!-- Кнопка подсказки -->
    <button
      mat-icon-button
      matSuffix
      [disabled]="aiChatService.isLoading"
      [matMenuTriggerFor]="suggestionsMenu"
      matTooltip="Show suggestions"
      class="stylish-button suggestion-button "
    >
      <mat-icon style="color: cornflowerblue;">question_mark</mat-icon>
    </button>
    <!-- Кнопка отправки -->
    <button
      mat-icon-button
      color="primary"
      matSuffix
      (click)="sendMessage()"
      [disabled]="!userInput || aiChatService.isLoading"
      class="stylish-button send-button"
    >
      <mat-icon>send</mat-icon>
    </button>

    <!-- Выпадающий список подсказок -->
    <mat-menu #suggestionsMenu="matMenu">
      <div class="d-flex align-items-center justify-content-between">
        <label><span class="fw-bold ms-2">Examples:</span></label>
        <mat-icon class="me-2" color="primary" [class.spin-icon]="promtLoading" role="button" (click)="$event.stopPropagation(); refreshPromts()">autorenew</mat-icon>
      </div>

      <button
        mat-menu-item
        *ngFor="let suggestion of suggestions"
        (click)="userInput = suggestion"
        class="stylish-menu-item text-truncate"
      >
        {{ suggestion }}
      </button>
    </mat-menu>
  </mat-form-field>
</div>